export default __webpack_public_path__ + "static/media/Japan.1bce754a.svg";